console.group("inicializando o pack js vendor");

// ✅ jQuery e expose-loader primeiro
import 'jquery'; // expose-loader já coloca $ e jQuery no global scope

document.addEventListener("DOMContentLoaded", () => {
    document.body.setAttribute("data-turbo-suppress-warning", "");

    import("@hotwired/turbo-rails");
});

// ✅ Plugins que dependem de jQuery
import 'jquery.rateit';
import 'remotipart';
// se estiver usando via yarn

// ou, se for o minificado da pasta vendor:

// ✅ Air-datepicker moderno, se precisar também como módulo (opcional)
import AirDatepicker from 'air-datepicker'

// ✅ Outros pacotes independentes
import VP from '@vimeo/player';
import 'animejs';
import 'romanjs';
import 'vanilla-picker';
import 'node-vibrant';
import 'croppie';
import 'photoswipe';
import 'photoswipe/dist/photoswipe-ui-default';
import '@rails/ujs';
import 'tippy.js';
import 'jssha';

// ✅ Scripts customizados da pasta vendor/js
import '../../vendor/js/datepicker_overrides.js';
import '../../vendor/js/dragula_wrapper.js';
import '../../vendor/js/foundation.js';
import '../../vendor/js/iv-viewer.js';
import '../../vendor/js/lvt-dialog.js';
import '../../vendor/js/lvt-doughnut.js';
import '../../vendor/js/lvt-empty_dialog.js';
import '../../vendor/js/rails-action-text.js';

import twemoji from '@twemoji/api';
import Banner from '../../vendor/js/lvt-banner.js';
import PKPhotoSwipeUI from './photoswipe-ui-overrides.js';
// ✅ Framework Rails
import Rails from '@rails/ujs';
Rails.start();
import Animator from 'animejs';


// ✅ Globals (se necessários)
global.Rails = Rails;
global.AirDatepicker = AirDatepicker;
global.anime = Animator;
global.Roman = require('romanjs');
global.Picker = require('vanilla-picker');
global.Vibrant = require('node-vibrant');
global.Croppie = require('croppie');
global.PhotoSwipe = require('photoswipe');
global.PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default');
global.PKPhotoSwipeUI = PKPhotoSwipeUI
global.jsSHA = require('jssha');
global.VideoPositionTracker = VP
global.Banner = Banner
global.twemoji = twemoji;

import tippy, { followCursor } from 'tippy.js';
global.tippy = tippy;

tippy.setDefaultProps({
    placement: 'left-start',
    animation: 'shift-away',
    arrow: true,
    allowHTML: true,
    followCursor: false,
    theme: 'app_theme',
    touch: ['hold', 300],
    plugins: [followCursor]
});

console.groupEnd();
